import React from 'react';
import { allowedDomains, getValidDomain } from '../config/domains';

// Dynamically import all reason images from the domains directory
const reasonContext = require.context('../domains', true, /reason\.png$/);
const defaultReason = require('../shared/assets/img/reason.png');

const Features = ({ data }) => {
  // Get the domain name from data or default to localhost
  const domainName = getValidDomain(data.domainName || 'localhost');
  
  // Try to find the matching reason image, fallback to default if not found
  const reasonImage = allowedDomains.includes(domainName)
    ? reasonContext(`./${domainName}/assets/img/reason.png`) || defaultReason
    : defaultReason;

  const { features } = data;

  return (
    <section id="features" className="features">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 text-center">
            <div className="section-heading">
              <h2>{features.title}</h2>
              <p className="text-muted">{features.description}</p>
              <hr />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="device-container">
              <div className="device-mockup">
                <div className="device">
                  <div className="screen">
                    <img 
                      src={reasonImage} 
                      alt="Reason to choose" 
                      className="img-responsive"
                      onError={(e) => {
                        console.error('Failed to load image:', e.target.src);
                        e.target.src = defaultReason;
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-8">
            <div className="container-fluid">
              <div className="row">
                {features.items.map((item, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="feature-item">
                      <i className={item.icon}></i>
                      <h3>{item.title}</h3>
                      <p className="text-muted">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;
